import React, { Component } from 'react';
import PropTypes from "prop-types";
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Tooltip from '@mui/material/Tooltip';
import { withTranslation } from 'react-i18next';
class EnhancedTableHead extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    createSortHandler = (property, field) => event => {
        this.props.onRequestSort(event, property, field);
    }

    render() {
        const { order, orderBy, sortId, t } = this.props;
        const rows = [
            {
                id: 'store',
                numeric: false,
                disablePadding: false,
                label: t("Report.TemperatureHis.Store"),
                padding: '10px',
                field: 'name'
            },
            {
                id: 'box',
                numeric: false,
                disablePadding: false,
                label: t("Report.TemperatureHis.Location"),
                padding: '10px',
                field: 'name'
            },
            {
                id: 'side',
                numeric: false,
                disablePadding: false,
                label: t("Report.TemperatureHis.Side"),
                padding: '10px',
                field: 'side'
            },
            {
                id: 'connectwith',
                numeric: false,
                disablePadding: false,
                label: t("Report.TemperatureHis.ConnectWith"),
                padding: '10px',
                field: 'connectwith'
            },
            {
                id: 'Action',
                numeric: false,
                disablePadding: false,
                label: t("Report.TemperatureHis.Actions"),
                padding: '10px',
                field: 'view'
            },
        ];
        return (
            <React.Fragment>
                <TableHead>
                    <TableRow>
                        {rows.map((row) => {
                            return (
                                <TableCell
                                    key={row.id}
                                    numeric={row.numeric}
                                    padding={row.disablePadding ? "none" : "default"}
                                    sortDirection={orderBy === row.id ? order : false}
                                    style={{ padding: row.padding, color: 'rgba(0, 0, 0, 0.54)' }}
                                >
                                    {['Date', 'Action'].includes(row.id) ?
                                        (
                                            <TableSortLabel style={{ cursor: 'text' }}>
                                                {row.label}
                                            </TableSortLabel>
                                        ) : (
                                            <Tooltip
                                                title={t("Global.Label.Filter.Sort")}
                                                placement={row.numeric ? "bottom-end" : "bottom-start"}
                                                enterDelay={300}
                                            >
                                                <TableSortLabel
                                                    active={orderBy === row.field && sortId === row.id}
                                                    direction={order}
                                                    onClick={this.createSortHandler(row.id, row.field)}
                                                >
                                                    {row.label}
                                                </TableSortLabel>
                                            </Tooltip>
                                        )}
                                </TableCell>
                            );
                        }, this)}
                    </TableRow>
                </TableHead>
            </React.Fragment>
        )
    }
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    sortId: PropTypes.string.isRequired
}
export default withTranslation()(EnhancedTableHead);



// WEBPACK FOOTER //
// ./src/components/reports/temparature_history/EnhancedTableHead.index.js